import {Ability} from '~/lib/ability';

export class CreativesAbility extends Ability {
    canViewCreatives = () => this.isAdmin() || this.isManager() || this.isEasybrain();
    canViewTopCreativesPreview = () => !this.isEasybrain() && (this.isAdmin() || this.sellerId() || this.isSelfServe());
}
